<template>
  <div ref="carouselRef" data-slot="carousel-content" class="tw:overflow-hidden">
    <div
      :class="
        cn(
          'tw:flex',
          orientation === 'horizontal' ? 'tw:-ml-4' : 'tw:-mt-4 tw:flex-col',
          props.class,
        )
      "
      v-bind="$attrs"
    >
      <slot />
    </div>
  </div>
</template>

<script setup>
// 1. Import necessary components
defineOptions({ name: 'UiCarouselContent', inheritAttrs: false });
import { cn } from '@/shared/utilities/classes';
import { useCarousel } from './useCarousel';

// 2. Use
const props = defineProps({
  class: {
    default: undefined,
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const { carouselRef, orientation } = useCarousel();
// 3. Define a reactive variable
// 4. Define methods or computed properties if needed
// 5. VueJS Hooks
</script>
